export default "__VITE_ASSET__DJX70SL6__"